export const FETCH_SEO_META_REQUEST = 'FETCH_SEO_META_REQUEST';
export const FETCH_SEO_META_SUCCESS = 'FETCH_SEO_META_SUCCESS';
export const FETCH_SEO_META_FAILURE = 'FETCH_SEO_META_FAILURE';
